var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "popular-phrase-item-container",
      style: { borderColor: _vm.item.highlightedBorderColor.hex },
    },
    [
      _c(
        "a",
        {
          staticClass: "popular-phrase-item-button",
          style: {
            backgroundColor: _vm.item.backgroundColor.hex,
            borderColor: _vm.item.backgroundColor.hex,
            color: _vm.item.textColor.hex,
          },
          attrs: { href: _vm.href },
          on: {
            click: function ($event) {
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.handleClick.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.item.label) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }